import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import { actionAddSiteStaticPagesData } from './siteFooterPages';

import {
  ACTION_LOAD_SITE_STATIC_PAGES__REQUEST,
  ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS,
  ACTION_LOAD_SITE_STATIC_PAGES__FAIL,
} from '../actionTypes';


const actionLoadSiteStaticPagesSuccess = () => ({
  type: ACTION_LOAD_SITE_STATIC_PAGES__SUCCESS,
});

const actionLoadSiteStaticPagesFail = error => ({
  type: ACTION_LOAD_SITE_STATIC_PAGES__FAIL,
  payload: { error },
});

export const actionLoadSiteStaticPagesRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_STATIC_PAGES__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site_content/static_page/site/${getCurrentSiteId(getState())}`
    ).then(
      result => {
        actionAddSiteStaticPagesData(dispatch, result);
        dispatch(actionLoadSiteStaticPagesSuccess());
      },
      error => {
        dispatch(actionLoadSiteStaticPagesFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
